import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import OfferDetails from "./pages/offerDetails";
import VehicleDetails from "./pages/vehicleDetails";
import LoanDetails from "./pages/LoanDetails";
import ReviewDetails from "./pages/reviewDetails";
import PersonalDetails from "./pages/personalDetails";
import Confirmation from "./pages/confirmation";
import Declaration from "./pages/declaration";
import higherLoanApplyForm from "../common/page/higherLoanApplyForm";
import SanctionLetterApproval from "./pages/sanctionLetterApproval";
import ErrorTechnical from "../common/page/errorEechnical";
import HigherLoanApplyThankYou from "../common/page/higherLoanApplyThankYou";

const QM10Route = () => (
    <Router basename="/qm-10-seconds">
        <Switch>
            <Redirect exact from="/" to="/offer" />
            <Route exact path="/offer" component={OfferDetails} />
            <Route exact path="/vehicle-details" component={VehicleDetails} />
            <Route exact path="/loan-details" component={LoanDetails} />
            <Route exact path="/review" component={ReviewDetails} />
            <Route exact path="/personal-details" component={PersonalDetails} />
            <Route exact path="/confirmation" component={Confirmation} />
            <Route
                exact
                path="/sanction-letter-approval"
                component={SanctionLetterApproval}
            />
            <Route exact path="/declaration" component={Declaration} />
            <Route
                exact
                path="/higher-loan-apply-form"
                component={higherLoanApplyForm}
            />
            <Route
                exact
                path="/higher-loan-thank-you"
                component={HigherLoanApplyThankYou}
            />
            <Route exact path="/error" component={ErrorTechnical} />
            <Route exact>
                <h1>404 not Found</h1>
            </Route>
        </Switch>
    </Router>
);

export default QM10Route;
